var React = require('react');

function BtnInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.2929 29.2929C15.9024 29.6834 15.9024 30.3166 16.2929 30.7071L22.6569 37.0711C23.0474 37.4616 23.6805 37.4616 24.0711 37.0711C24.4616 36.6805 24.4616 36.0474 24.0711 35.6569L18.4142 30L24.0711 24.3431C24.4616 23.9526 24.4616 23.3195 24.0711 22.9289C23.6805 22.5384 23.0474 22.5384 22.6569 22.9289L16.2929 29.2929ZM43 29L17 29L17 31L43 31L43 29Z","fill":"#9A9A9A"}));
}

BtnInline.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = BtnInline;

BtnInline.default = BtnInline;
